import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/video-player/components/VideoPlayerContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/AppLayout.tsx");
